import PageLoader from '@/common/service/flow/page-loader';
import { buildAccountBaseService } from '@/common/service/base-paid';
import { loadSelectByPersist } from '@/common/service/plan-data-mapper';
import { pageConfig } from '@/common/service/page-config';
import _ from 'lodash';
import { getPlansMap } from '@/common/product';
import {
  planTypes,
  usageTypeMap,
  VIEWS,
} from '@/common/constants';
import Flow from '@/flows/flow';
import { disabledBoughtPlansWithCampaign } from '@/views/config/coupon/helper/preload';
import { addQtyParser } from './helper/add-qty-parser';
import loadDefaultSelectByQuery from './helper/load-by-url.upsell';
import { submitUpsell, beforeSubmitUpsell } from './helper/submit.upsell';
import { checkDependentCallingPlan } from '../utils';

const addType = pageConfig?.editConfig?.planType;

export const filterDisabledPlansWithSubscription = (allPlanResult = {}, subscriptions = []) => {
  const { disablePlanCodeList = [], disablePlanCategoryList = [] } = allPlanResult;
  const subscriptionsMap = getPlansMap(subscriptions);

  return (planMapFlat = []) => {
    return _.filter(planMapFlat, (p) => {
      const boughtPlanIsInPlanMap = _.has(subscriptionsMap, p?.plan_code);

      if (_.includes(disablePlanCodeList, p?.plan_code) && !boughtPlanIsInPlanMap) {
        return false;
      }

      if (_.includes(disablePlanCategoryList, p?.plan_code) && !boughtPlanIsInPlanMap) {
        return false;
      }

      return true;
    });
  };
};

const removeOtherPlanForBizPlus = (boughtPlans) => {
  return (planMapFlat) => {
    const bundlePlan = boughtPlans.find(
      (item) => (
        item.type === planTypes.ZOOM_ONE_BUNDLE ||
        item.type === planTypes.ZOOM_UNITED ||
        item.type === planTypes.ZONE_EDU_PLUS ||
        item.type === planTypes.ZONE_PRO_PLUS
      ),
    );
    if (bundlePlan) {
      return planMapFlat.filter(
        (item) => item.type !== planTypes.ZOOM_MEETING || item.category === bundlePlan.meeting_category,
      );
    }
    return planMapFlat;
  };
};

const removePendingPlan = (boughtPlans) => {
  const pendingPlanCodes = boughtPlans.filter(p => p.cartInfo?.has_downgrade_request || p.cartInfo?.has_decrease_request || p.cartInfo?.has_same_pending_plan).map(p => p.plan_code);
  return (planMapFlat) => {
    return planMapFlat.filter(item => !pendingPlanCodes.includes(item.plan_code));
  };
};

let upsellView = VIEWS.COMPOUND;

export default class UpsellFlow extends Flow {
  view() {
    const isAddZoomPhone = pageConfig.editConfig.planType === planTypes.ZOOM_PHONE;
    if (!isAddZoomPhone) {
      upsellView = VIEWS.COMPOUND;
    } else {
      // add2cart of zp, may be directed to different views
      const isPersonalUsage = window.$config('usageType') === usageTypeMap.personal;
      // for non biz usage, force 2 step & fill in biz usage fields
      upsellView = isPersonalUsage ? VIEWS.CONFIG : VIEWS.COMPOUND;
    }
    return upsellView;
  }
  async init(state) {
    const { persist } = state;
    const isNeedCallPbx = addType === planTypes.ZOOM_PHONE;
    let { planMap, subscriptions, boughtPlans, freeTrialPlans, allPlanMap } = await buildAccountBaseService({
      isNeedCallPbx,
    });
    subscriptions = disabledBoughtPlansWithCampaign(subscriptions, boughtPlans);
    const loader = new PageLoader(planMap);
    loader.decorate(
      'filterDisabledPlansWithSubscription',
      filterDisabledPlansWithSubscription(allPlanMap, subscriptions),
    );
    loader.decorate('removeOtherPlanForBizPlus', removeOtherPlanForBizPlus(boughtPlans));
    loader.decorate('loadByPersist', loadSelectByPersist(persist));
    loader.decorate('removePendingPlan', removePendingPlan(boughtPlans))
    loader.decorate('loadDefaultSelectByQuery', loadDefaultSelectByQuery(boughtPlans));
    loader.decorate('checkDependentCallingPlan', checkDependentCallingPlan(boughtPlans));

    const planList = await loader.dispatch();
    return {
      allPlanMap,
      boughtPlans,
      subscriptions,
      freeTrialPlans,
      planMapFlat: planList,
    };
  }
  afterInit() {
    return addQtyParser();
  }
  beforeSubmit() {
    const needCheckZmHardware = upsellView === VIEWS.COMPOUND;
    return beforeSubmitUpsell(needCheckZmHardware);
  }
  submit(submitParams) {
    return submitUpsell(submitParams);
  }
}
